import ForgotPasswordPage from "./ForgotPasswordPage";

const module = {
  routeProps: {
    path: "DownloadUser/ForgotPassword",
    component: ForgotPasswordPage,
  },
  name: "Download User Forgot Password",
  label: "Forgot Password",
  title: "Forgot Password",
  showOnMenu: false,
};

export default module;
